import { USER_CONSTANTS } from "@src/constants/UiConstants";

 export const isAdmin = (role: string) => {
  return [
    USER_CONSTANTS.SUPER_ADMIN,
    USER_CONSTANTS.SUPER_ADDER,
    USER_CONSTANTS.SUPER_VERIFIER,
    USER_CONSTANTS.SUPER_TRAINER,
  ].includes(role);
};

 export const isTrainer = (role: string) => {
  return [
    USER_CONSTANTS.TRAINER,
    USER_CONSTANTS.QUESTION_ADDER,
    USER_CONSTANTS.QUESTION_VERIFIER,
  ].includes(role);
};

export const isOrgUser = (role: string) => {
  return !isAdmin(role) && !isTrainer(role) && 
         role !== USER_CONSTANTS.STUDENT && 
         role !== USER_CONSTANTS.SUPER_TASK_MANAGER && role!== USER_CONSTANTS.TASK_MANAGER;
};